type ExpleeCompany = {
  domain?: string;
  name?: string;
  description?: string;
  description_website?: string;
  url?: string;
  linkedin_id?: number;
  industry?: string;
  geo?: string;
  geo_subdivision?: string;
  geo_city?: string;
  geo_countries?: Record<string, number>;
  geo_country_employees?: Record<string, number>;
  geo_founders?: string[];
  size?: number;
  founded?: number;
  traffic?: number;
  traffic_growth?: number;
  traffic_by_country?: Record<string, number>;
  traffic_by_months?: Record<string, number>;
  web_metrics_bounce_rate?: number;
  web_metrics_pages_per_visit?: number;
  web_metrics_time_on_site?: number;
  marketing_pixels?: string[];
  revenue_annual?: number;
  funding_stage?: string;
  funding_date?: string;
  funding_last_round_stage?: string;
  funding_last_round_date?: string;
  funding_last_round_amount?: number;
  hiring?: boolean;
  employees_by_department?: Record<string, number>;
  emails?: string[];
  phones?: string[];
  social_facebook_urls?: string[];
  social_instagram_urls?: string[];
  social_x_urls?: string[];
  social_tiktok_urls?: string[];
  social_youtube_urls?: string[];
  social_linkedin_urls?: string[];
  criteria?: Record<string, { reasoning: string; score: number }>;
  match?: number;
};

type ExpleeResponse = {
  success: boolean;
  companies: ExpleeCompany[];
  meta: {
    total: number;
    results_count: number;
    credits_charged: number;
    remaining_balance: number;
  };
};

export async function searchExpleeCompanies(params: {
  definition: string;
  criteria?: string[];
  page: number;
  pageSize: number;
  geo?: string[];
  size_min?: number;
  size_max?: number;
  traffic_min?: number;
  hiring?: boolean;
  funding_stage?: string;
}): Promise<ExpleeResponse> {
  const body: Record<string, unknown> = {
    action: 'explee_search_companies',
    definition: params.definition,
    criteria: params.criteria ?? [],
    page: params.page,
    pageSize: params.pageSize,
  };
  if (params.geo?.length) body.geo = params.geo;
  if (params.size_min != null) body.size_min = params.size_min;
  if (params.size_max != null) body.size_max = params.size_max;
  if (params.traffic_min != null) body.traffic_min = params.traffic_min;
  if (params.hiring != null) body.hiring = params.hiring;
  if (params.funding_stage) body.funding_stage = params.funding_stage;

  const res = await fetchAPI<ExpleeResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!res.success) {
    throw new Error((res as any).error || 'Explee search failed');
  }

  return res;
}
import { API_CONFIG, fetchAPI } from './api';
